module.exports = __webpack_public_path__ + "img/eprf-lorry.3b63d3f5.png";